// This file is automatically generated. Do not edit it directly.
// DEPLOY: Do not replace or overwrite this file at deploy. findigo.se uses the production override below; replacing this file can make findigo.se show no jobs or break login.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

// Canonical production backend (AGENTS.md). When app runs on findigo.se we always use this so no build/deploy env can break it.
const PRODUCTION_SUPABASE_URL = 'https://vhiplwmomkjcgtponbvy.supabase.co';
const PRODUCTION_ANON_KEY = 'sb_publishable_F_a7pl_SPqhhCDdkIWCBew_Ynw4zBci';

function isProductionDomain(): boolean {
  if (typeof window === 'undefined') return false;
  const h = window.location?.hostname ?? '';
  return h === 'findigo.se' || h === 'www.findigo.se';
}

// Prioritet: 1) runtime-config (alltid om tillgänglig, även på findigo.se – undviker 401 när Legacy API keys disabled), 2) production fallback, 3) env.
// Om runtime-config.js laddas med sb_publishable_* används den; annars findigo.se → PRODUCTION_* så deploy inte bryter.
const runtimeConfig = typeof window !== 'undefined'
  ? window.__RUNTIME_CONFIG__
  : undefined;

const envUrl = import.meta.env.VITE_SUPABASE_URL || import.meta.env.VITE_SB_URL;
const envKey = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY || import.meta.env.VITE_SUPABASE_ANON_KEY || import.meta.env.VITE_SB_PUBLISHABLE_KEY;

export const SUPABASE_URL = runtimeConfig?.SUPABASE_URL
  ?? (isProductionDomain() ? PRODUCTION_SUPABASE_URL : envUrl)
  ?? PRODUCTION_SUPABASE_URL;

export const SUPABASE_PUBLISHABLE_KEY = runtimeConfig?.SUPABASE_PUBLISHABLE_KEY
  ?? (isProductionDomain() ? PRODUCTION_ANON_KEY : envKey)
  ?? PRODUCTION_ANON_KEY;

if (!SUPABASE_URL || !SUPABASE_PUBLISHABLE_KEY) {
  throw new Error('[Supabase] Missing config. Set VITE_SUPABASE_URL/KEY or add public/runtime-config.js');
}

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

// PKCE flow: OAuth callback uses ?code=... instead of #access_token=..., so no inline script
// is needed to parse the hash — avoids CSP "script-src" blocking on strict hosting (e.g. findigo.se).
const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    flowType: 'pkce',
  }
});

export { supabase };

/**
 * Debug: URL + anon key project ref (JWT payload.ref). Logga aldrig nyckeln.
 * I prod: returnerar redigerad stub – anropas endast från Auth debug som är DEV-guardad.
 * Apple/FAANG: minimera exponering av backend-identiteter i klient (APPLE_FAANG_INTE_ACCEPTERAT #5).
 */
export function getSupabaseDebug(): { url: string; keyProjectRef: string | null; expectedRef: string } {
  if (import.meta.env.PROD) {
    return { url: "", keyProjectRef: null, expectedRef: "" };
  }
  let keyProjectRef: string | null = null;
  try {
    const parts = SUPABASE_PUBLISHABLE_KEY.split(".");
    if (parts.length === 3) {
      const b64 = parts[1].replace(/-/g, "+").replace(/_/g, "/");
      const p = JSON.parse(atob(b64));
      keyProjectRef = p.ref ?? null;
    }
  } catch {
    void 0; /* ignore JWT decode errors when extracting project ref */
  }
  return { url: SUPABASE_URL, keyProjectRef, expectedRef: "vhiplwmomkjcgtponbvy" };
}
